import React from 'react';

const Icon = ({ className }) => (
    <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill='#000' xmlns="http://www.w3.org/2000/svg">
        <path d="M19.3333 18.5333L17.0756 20.7822C15.7138 20.0649 14.6231 19.2293 13.6996 18.3004C12.7707 17.3769 11.9351 16.2862 11.2178 14.9244L13.4667 12.6667L12.8996 8H8C8 8 8 8.29156 8 8.88889C8 12.9236 9.63556 16.7769 12.4142 19.5858C15.2231 22.3644 19.0764 24 23.1111 24C23.7084 24 24 24 24 24V19.1004L19.3333 18.5333Z"/>
    </svg>
);

export default Icon;
